import React, { memo, useState } from 'react';
import icons from '../ultils/icons';
import { Link } from 'react-router-dom';
import { formatVietnameseToString } from '../ultils/common/formatVietnameseToString ';
import { path } from '../ultils/constant';
const { HiHeart, HiOutlineHeart, AiOutlineStar, BsFillBookmarkStarFill } = icons;
const Item = ({ images, user, title, star, description, attributes, address, id }) => {
    const [isHoverHeart, setIsHoverHeart] = useState(false);
    const handleStar = (star) => {
        let stars = [];
        for (let i = 1; i <= +star; i++) stars.push(<AiOutlineStar className="star-item" size={22} color="yellow" />);
        return stars;
    };
    return (
        <div className="w-full flex gap-4 border-t border-orange-600 p-4 ">
            <Link to={`${path.DETAIL}${formatVietnameseToString(title?.replaceAll('/', ''))}/${id}`} className="w-2/5">
                <div className="relative cursor-pointer">
                    {/* {images.length > 0 && images.filter(i,index) => indexs.some(i => i === index))?.map(i => {
                        return (
                            <img src={images[i]} alt="preview" className='w-[280px] h-[309px] object-cover' />
                        )
                    })} */}
                    <img src={images[0]} alt="preview" className="w-[280px] h-[309px] object-cover" />
                    <span className="bg-overlay-70 text-white px-2 rounded-md absolute left-1 bottom-1">{`${images.length} ảnh`}</span>
                    <span
                        className="text-white absolute right-5 bottom-1"
                        onMouseEnter={() => setIsHoverHeart(true)}
                        onMouseLeave={() => setIsHoverHeart(false)}
                    >
                        {isHoverHeart ? <HiHeart size={26} color="red" /> : <HiOutlineHeart size={26} />}
                    </span>
                </div>
            </Link>
            <div className="w-3/5 ">
                <div className="flex justify-between gap-4">
                    <div className="text-red-600 font-medium">
                        {handleStar(+star).length > 0 &&
                            handleStar(+star).map((star, number) => {
                                return <span key={number}>{star}</span>;
                            })}
                        {title}
                    </div>
                </div>
                <div className="my-2 flex items-center justify-between gap-2">
                    <span className="font-bold flex-3 text-green-600">{attributes?.price}</span>
                    <span className="flex-1">{attributes?.acreage}</span>
                    <span className="flex-3 whitespace-nowrap overflow-hidden text-ellipsis">
                        {`${address.split(',')[address.split(',').length - 2]}${
                            address.split(',')[address.split(',').length - 1]
                        }`}
                    </span>
                </div>
                <p className="text-gray-500 w-full h-[100px] text-ellipsis overflow-hidden">{description}</p>
                <div className="flex items-center my-5 justify-between">
                    <div className="flex items-center">
                        <img
                            src="http://bestnycacupuncturist.com/wp-content/uploads/2016/11/anonymous-avatar-sm.jpg"
                            alt="avatar"
                            className="w-[30px] h-[30px] object-cover rounded-full"
                        />
                        <p>{user?.name}</p>
                    </div>
                    <div className="flex items-center gap-1">
                        <a
                            type="button"
                            className="bg-blue-700 text-white p-1 rounded-md"
                            href="tel:0348774777"
                            target="_blank"
                        >
                            {`Gọi ${user?.phone}`}
                        </a>
                        <a
                            type="button"
                            className="text-blue-700 px-1 rounded-md border border-blue-700"
                            href={`https://zalo.me/${user?.zalo}`}
                            target="_blank"
                        >
                            Nhắn Zalo
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(Item);
// object-cover: Đây là một class Tailwind CSS khác để đảm bảo rằng hình ảnh sẽ bị cắt đi để vừa với kích thước được định nghĩa trong w-[140px] và h-[120px] mà không bị biến dạng
// chú ý dòng 32-36 star-item được định nghĩa bên tailwind.config.js
